// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import localesJson from '../assets/i18n/locales.json';
import { parseLanguages } from './common';
/*
 * enum SUPPORTED_LANGUAGE {
 *      DE_CH = 'DE_CH',
 *      EN = 'EN',
 *      FR_CH = 'FR_CH',
 *      IT_CH = 'IT_CH'
 * }
 */

export const GOOGLE_MAPS_API_KEY_NON_PROD = 'AIzaSyBOgvNtAVoDQzL-077Z1t5kntLS1XgIBBg';

const DFS_IDENTITYSERVER_CLIENT = 'mad';
const DFS_IDENTITYSERVER_SECRET = '';

export const SL_SSO_CLIENT_NON_PROD = '4533c74f15af40289bd3600a4eebb9cc';
export const SL_SSO_URL_NON_PROD = 'https://id.uat.portals.swisslife.ch';

export const TRANSLATIONS_BASE_URL = 'https://translate.swissfex.ch/i18n/';

export interface MadEnvironment {
    apiUrl?: string;
    backofficeProjectUrl?: string;
    dfsIdentityServerClient: string;
    dfsIdentityServerSecret: string;
    dfsIdentityServerUrl?: string;
    diagnosticLogKeyBase?: string;
    documentIds: {
        LENDER_SPECIFIC_DOCUMENTS_CATEGORY_ID: number;
        INBOX_CATEGORY_ID: number;
    };
    features?: {
        clarity: {
            isEnabled: boolean;
            key: string | null;
        };
        hypoDossier: {
            baseUrls: {
                component: string;
                service: string;
            };
            features: {
                closePreviewOnDocumentNotFoundEvent: boolean;
            };
            scriptType: 'module' | 'text/javascript';
        };
        hypoDossierCdp: {
            cdpBackendUrl: string;
            cdpIframeUrl: string;
            authTokenRefreshInterval: number;
            enableConsoleLogs: boolean;
            sfxEnableBadgeDebug: boolean;
        };
        documents: {
            useRedesignedDocumentsPage: boolean;
        };
    };
    googleMapsApiKey?: string;
    inactivityTimeout: {
        monitor: number;
        logout: number;
    };
    isDfsIdentityServerAuthenticationEnabled: boolean;
    lenderIds: Record<string, number>;
    name?: string;
    notificationsUrl?: string;
    originsPerUserType?: Record<string, string>;
    production: boolean;
    refreshTokenConfig: {
        sl: {
            isEnabled: boolean;
        };
        dfs: {
            isEnabled: boolean;
        };
    };
    service: {
        email: string;
    };
    slSsoClient: string;
    slSsoUrl: string;
    supportedLanguages: string[];
    title?: string;
    translationsFallbackUrl: string;
    translationsUrl?: string;
}

export const ENVIRONMENT_BASE: MadEnvironment = {
    production: false,
    supportedLanguages: parseLanguages(localesJson),

    dfsIdentityServerClient: DFS_IDENTITYSERVER_CLIENT,
    dfsIdentityServerSecret: DFS_IDENTITYSERVER_SECRET,
    documentIds: {
        LENDER_SPECIFIC_DOCUMENTS_CATEGORY_ID: 5,
        INBOX_CATEGORY_ID: 100
    },
    inactivityTimeout: {
        monitor: 20 * 60 * 1000,
        logout: 10 * 60 * 1000
    },
    isDfsIdentityServerAuthenticationEnabled: true,
    lenderIds: {
        ACREVIS: 11500,
        ASGA: 9100,
        BANK_CLER: 10200,
        BANK_FRICK: 12000,
        BANK_SLM: 13400,
        BANK_THALWIL: 12100,
        BCV: 13500,
        BDL: 8700,
        BEKB: 8200,
        BLKB: 13600,
        BPS: 9000,
        CER: 12500,
        CREDIT_SUISSE_DE: 8000,
        CREDIT_SUISSE_FR: 8001,
        CREDIT_SUISSE_IT: 8002,
        DEMO: 1002,
        E_HYPO: 8600,
        EDELWEISS: 12300,
        GKB: 8300,
        GLKB: 9200,
        LLB: 13200,
        LUKB: 10100,
        MIGROS_BANK: 9800,
        PAX: 10400,
        PSW: 9300,
        RAIFFEISEN_ALPES_RIVIERA_CHABLAIS_VAUDOIS: 13000,
        RAIFFEISEN_BELALP_SIMPLON: 9700,
        RAIFFEISEN_BENKEN: 11900,
        RAIFFEISEN_CASSARATE: 12800,
        RAIFFEISEN_DU_HAUT_LEMAN: 11300,
        RAIFFEISEN_DU_MONT_TENDRE: 11200,
        RAIFFEISEN_FRICK_METTAUERTAL: 11600,
        RAIFFEISEN_GENEVE_RHONE: 10600,
        RAIFFEISEN_GLARNERLAND: 10500,
        RAIFFEISEN_GRAUHOLZ: 12200,
        RAIFFEISEN_LOCARNO: 8500,
        RAIFFEISEN_LOSONE_PEDEMONTE_VALLEMAGGIA: 8400,
        RAIFFEISEN_LUGANO: 12700,
        RAIFFEISEN_LUZERN: 11700,
        RAIFFEISEN_MARTIGNY: 10900,
        RAIFFEISEN_MASSONGEX: 13700,
        RAIFFEISEN_MISCHABEL_MATTERHORN: 11800,
        RAIFFEISEN_MITTELRHEINTAL: 10700,
        RAIFFEISEN_MUNCHWILEN_TOBEL: 12400,
        RAIFFEISEN_NYON_LA_VALLEE: 10300,
        RAIFFEISEN_RAPPERSWIL_JONA: 10800,
        RAIFFEISEN_REGION_DELEMONT: 12900,
        RAIFFEISEN_SEELAND: 12600,
        RAIFFEISEN_SANKT_GALLEN: 8080,
        RAIFFEISEN_SION: 11000,
        RAIFFEISEN_SURBTAL_WEHNTAL: 11100,
        RAIFFEISEN_SIERRE_REGION: 10000,
        RAIFFEISEN_VISP: 13300,
        RAIFFEISEN_WINTERTHUR: 9600,
        RAIFFEISEN_ZURICH_UNTERLAND: 13100,
        SOBA: 8800,
        SUVA: 8900,
        SWISS_LIFE: 30,
        SWISSCANTO_ANLAGESTIFTUNG: 9400,
        UBS: 137,
        UBS_KEY4: 9500,
        WIR_BANK: 9900,
        WKB: 8100,
        ZKB: 11400
    },
    refreshTokenConfig: {
        sl: {
            isEnabled: false
        },
        dfs: {
            isEnabled: true
        }
    },
    service: {
        email: 'service@swissfex.ch'
    },
    slSsoClient: SL_SSO_CLIENT_NON_PROD,
    slSsoUrl: SL_SSO_URL_NON_PROD,
    translationsFallbackUrl: '/assets/i18n/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
